import { useEffect, useState } from 'react';
import { Text, Group } from '@mantine/core';

function isoWeek(d: Date): { year: number; week: number } {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = (t.getUTCDay() + 6) % 7; // Mon=0
  t.setUTCDate(t.getUTCDate() - day + 3);
  const firstThursday = new Date(Date.UTC(t.getUTCFullYear(), 0, 4));
  const diff = (t.getTime() - firstThursday.getTime()) / 86400000;
  return { year: t.getUTCFullYear(), week: 1 + Math.round(diff / 7) };
}

/**
 * Дата, время и номер ISO-недели.
 *
 * Роли отсюда убраны при редизайне внутреннего портала (07.08.2026): и каркас,
 * и «Рабочий стол» показывают их сами, рядом получалось два одинаковых набора чипов.
 */
export function NowBar() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000 * 30);
    return () => clearInterval(t);
  }, []);
  const { year, week } = isoWeek(now);
  const date = now.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const time = now.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  return (
    <Group gap="xs" wrap="nowrap">
      <Text size="xs" c="dimmed">{date} {time}</Text>
      <Text size="xs" c="dimmed">·</Text>
      <Text size="xs" c="dimmed">неделя {week}, {year}</Text>
    </Group>
  );
}
